import { render } from "./ChallengeBoard.vue?vue&type=template&id=49a802d2&scoped=true"
import script from "./ChallengeBoard.vue?vue&type=script&lang=js"
export * from "./ChallengeBoard.vue?vue&type=script&lang=js"

import "./ChallengeBoard.vue?vue&type=style&index=0&id=49a802d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a802d2"]])

export default __exports__